<template>
  <div>
    <tool-bar
      :title="title"
      subTitle="Phone Number"
      :show-right-menu="false"
    ></tool-bar>

    <!--Benifits -->
    <div class="input_container margin-top-20">
      <weex-text v-if="benifitsTitle" class="font-size-base text-color-gray">
        <strong>{{ benifitsTitle }}</strong>
      </weex-text>
      <div class="input_container margin-bottom-10">
        <div v-for="(benifit, index) in benifitPoints" :key="index">
          <weex-text class="text-color-gray margin-bottom-10">
            <div class="circle"> &#10003; </div>
            <span class="font-size-base">{{ benifit }}</span>
          </weex-text>  
        </div>
      </div>
    </div>
    <!--Benifits end-->

    <hr class="margin-top-20" />

    <!--Process -->
    <div class="input_container margin-top-20">
      <weex-text v-if="processTitle" class="font-size-base text-color-gray">
        <strong>{{ processTitle }}</strong>
      </weex-text>
      <div class="input_container margin-bottom-10 row">
        <div class="column" v-for="(step, index) in processSteps" :key="index">
          <weex-image :src="getImgUrl(step.retailerProcessImageName)" class="process-img"></weex-image>
          <weex-text class="text-color-gray margin-bottom-10">
            <div class="font-size-sm"> <strong> {{index+1}}. {{ step.retailerProcessTitle }}</strong></div>
          </weex-text>
        </div>
      </div>
    </div>
    <!--Process end-->

    <wxc-button v-if="showCheckEligibiltyButton"
      text="Check Eligibility"
      class="horizontal-center margin-top-40 margin-bottom-20"
      size="big"
      type="blue"
      @wxcButtonClicked="onContinue"
    ></wxc-button>
  </div>
</template>

<script>
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import { ImageResourcesUtil } from "../../../utils/ImageResourcesUtil";
import ActivityNavigator, { Activities } from "../../../utils/ActivityNavigator";
import ToolBar from "../../layout/ToolBar";
import CoBrandingDataHolder from '../../../data/model/CoBrandingDataHolder';

export default {
  name: "WelcomeCobrandingActivity",
  components: { ToolBar, WxcButton },

  data: () => ({
    benifitsTitle: "Need Easy EMI?",
    processTitle: "How Does It Works",
  }),

  props: {
    ezCredLogoSrc: {
      type: String,
      required: true
    },
    coBrandingLogoSrc: {
      type: String,
      required: true
    },
    benifitPoints: {
      type: Array,
      required: true
    },
    processSteps: {
      type: Array,
      required: true
    },
  },

  methods: {

    onContinue() {
      ActivityNavigator.navigateTo(Activities.LOGIN);
    },

    getImgUrl(img) {
      try{
        var images = require.context('../../../../src/assets/', false, /\.png$/)
        return images('./' + img + ".png")
      }catch{
        return images('./HappyMan.png');
      }
    }
  },

  computed: {
    title() {
      return this.isOnboardingProcess
        ? "Welcome to Dealer Onboarding"
        : "Welcome";
    },

    showCheckEligibiltyButton(){
      return CoBrandingDataHolder.isURLValid();
    }
  },
};
</script>

<style
  scoped
  src="../../../assets/style/base.css"></style>

<style scoped>
.logo {
  width: 120px;
}
.star-icon {
  font-size: 8px;
  vertical-align: bottom;
  padding-right: 5px;
}
/* Create two equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  padding: 10px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.process-img{
  height: 30px;
}

.circle {
  width: 15px;
  height: 15px;
  line-height: 15px;
  border-radius: 15px;
  color: #fff;
  text-align: center;
  background: #4dad5a;
  margin-right: 5px;
  display: inline-block;
}


</style>
